import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'

@observer
class OptionResponse extends Component {
    toggleFilter = (e) => {
        const { reportStore } = this.props
        const { value, checked } = e.target
        if (checked) {
            reportStore.reportFilters.push(value)
        } else {
            const index = reportStore.reportFilters.indexOf(value)
            if (index > -1) {
                reportStore.reportFilters.splice(index, 1)
            }
        }
    }

    render() {
        const {
            value,
            id,
            reportStore,
            pct,
        } = this.props
        return (
            <Fragment>
                {reportStore.filterIsOpen && (
                    <input
                        value={id}
                        defaultChecked={reportStore.reportFilters.includes(id)}
                        type="checkbox"
                        style={{ float: 'left' }}
                        onClick={this.toggleFilter}
                    />
                )}
                {/* minWIdth to align quickFilter checkboxes (30px ~ 4 digits) */}
                <div data-value={id} style={{ minWidth: '30px' }}>
                    {value}
                    {pct ? '%' : ''}
                </div>
            </Fragment>
        )
    }
}

export default OptionResponse
